export const API_VERSION = {
  V1: "v1",
} as const;

type ApiVersionType = typeof API_VERSION;

const versionedUrl = (version: ApiVersionType[keyof ApiVersionType], path: string) =>
  `api/${version}/${path}`;

// swagger for staging is here: https://digifirst-api.staging.goodylabs.cloud/swagger
export const routes = {
  auth: {
    loginByCode: versionedUrl(API_VERSION.V1, "auth/login-by-code/"),
    refreshToken: versionedUrl(API_VERSION.V1, "auth/refresh-token/"),
    profile: versionedUrl(API_VERSION.V1, "auth/profile/"),
  },
  articles: {
    list: versionedUrl(API_VERSION.V1, "articles/"),
    wagtailList: versionedUrl(API_VERSION.V1, "old-articles/"),
    resolveLink: versionedUrl(API_VERSION.V1, "old-articles/resolve-link/"),
    details: (articleId: string | number) => versionedUrl(API_VERSION.V1, `old-articles/${articleId}/`),
    create: versionedUrl(API_VERSION.V1, "articles/"),
    migrateOldToNew: versionedUrl(API_VERSION.V1, "articles/create-from-wagtail/"),
    archive: (articleId: string | number) => versionedUrl(API_VERSION.V1, `articles/${articleId}/archive/`),
    unpublish: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/unpublish/`),
    republish: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/republish/`),
    imagesStatus: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/images-status/`),
    purgeCache: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/purge-cache/`),
    schedule: (articleId: string | number) => versionedUrl(API_VERSION.V1, `articles/${articleId}/schedule/`),
    backToDraft: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/back-to-draft/`),
    cancelPublish: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/cancel-publish/`),
    collabKey: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `articles/${articleId}/collab-key/`),
    delete: (articleId: string | number) => versionedUrl(API_VERSION.V1, `articles/${articleId}/`),
    topics: versionedUrl(API_VERSION.V1, "old-topics/"),
    tags: versionedUrl(API_VERSION.V1, "old-tags/"),
    collections: versionedUrl(API_VERSION.V1, "old-collections/"),
    appleNewsSections: versionedUrl(API_VERSION.V1, "apple-news/sections/"),
  },
  media: {
    list: versionedUrl(API_VERSION.V1, "old-images/"),
    create: versionedUrl(API_VERSION.V1, "old-images/create/"),
    detail: (id: number) => versionedUrl(API_VERSION.V1, `old-images/${id}/`),
    download: (id: number) => versionedUrl(API_VERSION.V1, `old-images/${id}/download/`),
  },
  embedAssets: {
    upload: versionedUrl(API_VERSION.V1, "articles/embed-assets/upload/"),
  },
  journalists: {
    list: versionedUrl(API_VERSION.V1, "old-journalists/"),
    create: versionedUrl(API_VERSION.V1, "old-journalists/create/"),
  },
  puzzles: {
    types: versionedUrl(API_VERSION.V1, "old-puzzles/types/"),
    lookup: versionedUrl(API_VERSION.V1, "old-puzzles/lookup/"),
  },
  google: {
    listDocs: versionedUrl(API_VERSION.V1, "google-docs/"),
    contents: (google_file_id: string) =>
      versionedUrl(API_VERSION.V1, `google-docs/${google_file_id}/content/`),
    importDoc: (googleDocId: string) => versionedUrl(API_VERSION.V1, `google-docs/${googleDocId}/`),
  },
  recipes: {
    detail: (id: number) => versionedUrl(API_VERSION.V1, `recipes/${id}/`),
  },
  presence: {
    article: (articleId: string | number) => versionedUrl(API_VERSION.V1, `articles/${articleId}/presence/`),
    bulk: versionedUrl(API_VERSION.V1, "presence/"),
  },
  youtube: {
    videos: versionedUrl(API_VERSION.V1, "youtube/videos/"),
  },
  grid: {
    collections: versionedUrl(API_VERSION.V1, "grid/collections/"),
    images: versionedUrl(API_VERSION.V1, "grid/images/"),
    import: versionedUrl(API_VERSION.V1, "grid/import/"),
    download: (imageId: string) => versionedUrl(API_VERSION.V1, `grid/images/${imageId}/download/`),
    image: (imageId: string) => versionedUrl(API_VERSION.V1, `grid/images/${imageId}/`),
  },
  woodwing: {
    books: versionedUrl(API_VERSION.V1, "woodwing/books/"),
    sendToPrint: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `woodwing/articles/${articleId}/send-copy-to-print/`),
    archive: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `woodwing/articles/${articleId}/archive/`),
    schedule: (articleId: string | number) =>
      versionedUrl(API_VERSION.V1, `woodwing/articles/${articleId}/schedule/`),
  },
};
